export interface Environment {
  production: boolean;
  apiUrl: string;
  wsUrl: string;
  websocketUrl: string;
  googleMapsApiKey: string;
}

export enum EnvironmentNames {
  LOCAL = 'LOCAL',
  DEV = 'DEV',
  STAGE = 'STAGE',
  PROD = 'PROD',
}

export const EnvironmentDomains: Record<string, EnvironmentNames> = {
  'localhost': EnvironmentNames.LOCAL,
  'dev.kms3.dqswarehouse.com': EnvironmentNames.DEV,
  'stage.kms3.dqswarehouse.com': EnvironmentNames.STAGE,
  'kms3.dqswarehouse.com': EnvironmentNames.PROD,
};
